import React from "react";
import "./Gurus.scss";
import { guruList } from "../../Data/Data";

const Gurus = () => {
    return (
        <section className="gurus" id="guru">
            <h6>THEY TAUGHT ME HOW TO SURVIVE IN THE TECH WORLD</h6>
            <h1>MY GURU</h1>
            <div className="gurus__lists">
                {guruList.map((g) => (
                    <div className="gurus__lists--details" key={g.id}>
                        <img
                            src={`./images/guru/${g.id}.png`}
                            alt="guru"
                            className="bgImg"
                        />
                        <p>{g.name}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Gurus;
